/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".app-footer[_ngcontent-%COMP%]{background:#fff;border-top:1px solid #eff0f6;justify-content:space-between;font-size:.8rem;font-weight:300}.app-footer[_ngcontent-%COMP%]   .sitisrl-link[_ngcontent-%COMP%]{font-weight:600;cursor:pointer;color:#1865ae}"];
export { styles as styles };
